import { useMemo } from 'react'
import useSubmissionGroups from '../../../sections/submissions/submission-groups/useSubmissionGroups'
import { SubmissionReviewStatuses } from '../../../../../constants/submission-review-statuses'

// If questionId is provided, returns first unreviewed submission for that question (approveStatus === 0)
// Otherwise, returns first unreviewed submission overall (by reviewStatus)
const useFirstUnreviewedSubmission = (questionRubricId) => {
    const { groups, submissions, isFetching } = useSubmissionGroups({ applyFilter: false, questionRubricId })
    
    const firstUnreviewedSubmission = useMemo(() => {
        if (!submissions || submissions.length === 0) return null
        
        // If we are on a specific question, use per-answer approveStatus
        if (questionRubricId) {
            const unreviewedForQuestion = submissions.find(submission => !submission.approveStatus)
            if (unreviewedForQuestion) {
                return { id: unreviewedForQuestion.id, groups }
            }
            return null
        }

        // Otherwise, find the first submission that is unreviewed or partially reviewed overall
        const unreviewedSubmission = submissions.find(
            submission =>
                submission.reviewStatus === SubmissionReviewStatuses.UNREVIEWED ||
                submission.reviewStatus === SubmissionReviewStatuses.PARTIALLY_REVIEWED,
        )
        
        if (unreviewedSubmission) {
            return {
                id: unreviewedSubmission.id,
                groups
            }
        }
        
        return null
    }, [submissions, groups, questionRubricId])
    
    return {
        firstUnreviewedSubmission,
        isFetching
    }
}

export default useFirstUnreviewedSubmission